"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EProductStatus = exports.EProductSocialMediaType = exports.EProductDisruptorType = exports.EProductAwards = void 0;
var EProductAwards;
(function (EProductAwards) {
    EProductAwards[EProductAwards["CODE_CHECK"] = 1] = "CODE_CHECK";
    EProductAwards[EProductAwards["COSMETIC_ANALYSIS"] = 2] = "COSMETIC_ANALYSIS";
    EProductAwards[EProductAwards["ECOCERT_BIOKOSMETIK"] = 3] = "ECOCERT_BIOKOSMETIK";
    EProductAwards[EProductAwards["ECOCERT_NATURALKOSMETIK"] = 4] = "ECOCERT_NATURALKOSMETIK";
    EProductAwards[EProductAwards["COSMOS_NATURAL"] = 5] = "COSMOS_NATURAL";
    EProductAwards[EProductAwards["COSMOS_ORGANIC"] = 6] = "COSMOS_ORGANIC";
    EProductAwards[EProductAwards["KOELNER_LISTE"] = 7] = "KOELNER_LISTE";
    EProductAwards[EProductAwards["LACON"] = 8] = "LACON";
    EProductAwards[EProductAwards["PATENTIERT"] = 9] = "PATENTIERT";
    EProductAwards[EProductAwards["UMWELTZEICHEN"] = 10] = "UMWELTZEICHEN";
    EProductAwards[EProductAwards["UVA_PROTECTION"] = 11] = "UVA_PROTECTION";
})(EProductAwards = exports.EProductAwards || (exports.EProductAwards = {}));
var EProductDisruptorType;
(function (EProductDisruptorType) {
    EProductDisruptorType["IMAGE"] = "image";
    EProductDisruptorType["NOT_SELECTED"] = "not-selected";
    EProductDisruptorType["VIDEO"] = "video";
})(EProductDisruptorType = exports.EProductDisruptorType || (exports.EProductDisruptorType = {}));
var EProductSocialMediaType;
(function (EProductSocialMediaType) {
    EProductSocialMediaType["ARTICLE"] = "article";
    EProductSocialMediaType["BLOG"] = "blog";
    EProductSocialMediaType["WEBSITE"] = "website";
})(EProductSocialMediaType = exports.EProductSocialMediaType || (exports.EProductSocialMediaType = {}));
var EProductStatus;
(function (EProductStatus) {
    EProductStatus[EProductStatus["DRAFT"] = 0] = "DRAFT";
    EProductStatus[EProductStatus["HIDDEN"] = 1] = "HIDDEN";
    EProductStatus[EProductStatus["PUBLISHED"] = 2] = "PUBLISHED";
    EProductStatus[EProductStatus["UNKNOWN"] = 3] = "UNKNOWN";
})(EProductStatus = exports.EProductStatus || (exports.EProductStatus = {}));
